import { LineItemDiscountProviderFunc } from "../LineItemDiscountsProvider";
import { translations, agradiDiscountSettings } from "./settings";

export const fetchAgradiLineItemDiscounts: LineItemDiscountProviderFunc = (
  originalLineItem,
  // Defined when the line item is an exchange
  nextLineItem,
  nextOrderState,
) => {
  const appliedDiscounts = originalLineItem.discounts;

  if (!appliedDiscounts || appliedDiscounts.length === 0) {
    return [];
  }

  // Check if this item has set discounts
  const isSetDiscount = appliedDiscounts.some((discount) => isSetDiscountTitle(discount.title));

  // If this item has a set discount, check if at least 2 items with set discounts are kept
  if (isSetDiscount) {
    // Count how many items with set discounts are in the kept items
    const setItemsWithDiscountsInKeptItems = nextOrderState.lineItems.filter((item) => {
      const itemDiscounts = item.discounts || [];
      return itemDiscounts.some((discount) => isSetDiscountTitle(discount.title));
    });

    // If fewer than 2 items with set discounts are kept, remove the set discount
    if (setItemsWithDiscountsInKeptItems.length < agradiDiscountSettings.minItemsForSetDiscount) {
      return appliedDiscounts.filter((discount) => !isSetDiscountTitle(discount.title));
    }
  }

  return appliedDiscounts;
};

/**
 * Returns true if the given discount title contains the set discount keyword.
 * This checks for both the original "set" keyword and translated "set-discount" phrases.
 *
 * @param discountTitle - The discount title to check.
 * @param translationsObj - The translations object to use (default: translations).
 * @returns boolean
 */
export function isSetDiscountTitle(
  discountTitle: string | null,
  translationsObj: Record<string, Record<string, string>> = translations,
): boolean {
  if (!discountTitle) return false;

  // Check for translated "set-discount" phrases
  const setDiscountTranslations = Object.values(translationsObj)
    .map((lang) => lang["set-discount"]?.toLowerCase())
    .filter(Boolean);

  // Split the title by comma, trim, and lowercase each part
  const titles = discountTitle
    .toLowerCase()
    .split(",")
    .map((t) => t.trim());

  return setDiscountTranslations.some((translated) => titles.includes(translated));
}
